import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUser, hasPermission } from '../utils/UserDetails';

function PrivateRoute({ component: Component, menuId, ...rest }) {

  return (
    <Route
      {...rest}
      render={props => {
        if (!getUser()) {
          return <Redirect to="/" />;
        }

        const param = hasPermission(menuId, 'canRead')
        if (menuId && !hasPermission(menuId, 'canRead')) {
          return <Redirect to="/users/unauthorized" />;
        }

        return <Component {...props} menuId={menuId} />;
      }}
    />
  );
}

export default PrivateRoute;
